<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <div class="white-common-box pa-5">
            <h3 class="subtitle-font mainColor--text">Create new user (no card)</h3>
            <p class="mb-3">
              Creates a validated account from a credit-only promo code. No confirmation email is sent and the user can log in right away.
            </p>
            <div v-if="errorMsg" class="notification is-danger is-light">
              {{ errorMsg }}
            </div>
            <div v-if="successMsg" class="notification is-success is-light">
              {{ successMsg }}
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label for="no-card-email" class="label">Email</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      id="no-card-email"
                      type="email"
                      class="input"
                      v-model="email"
                    />
                  </div>
                  <p v-if="email && !validEmail" class="help is-danger">Must be a valid email address.</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label for="no-card-password" class="label">Password</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      id="no-card-password"
                      type="password"
                      class="input"
                      v-model="password"
                    />
                  </div>
                  <p v-if="password && !passwordMinLength" class="help is-danger">Password must be at least 6 characters.</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label for="no-card-verify-password" class="label">Verify Password</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      id="no-card-verify-password"
                      type="password"
                      class="input"
                      v-model="verifyPassword"
                    />
                  </div>
                  <p v-if="verifyPassword && !passwordsMatch" class="help is-danger">Passwords do not match.</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label for="no-card-promo-code" class="label">Promo Code</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      id="no-card-promo-code"
                      type="text"
                      class="input"
                      v-model="promoCode"
                    />
                  </div>
                  <p class="help">Must be an approved credit-add coupon.</p>
                </div>
              </div>
            </div>

            <div class="text-right mt-3">
              <v-btn rounded
                color="profileAnchorColor"
                @click="submit"
                :disabled="!validForm"
                class="button-with-icon text-none whiteColor--text">
                <i class="fa fa-user-plus"></i>
                <span>Create user</span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      verifyPassword: '',
      promoCode: '',
      errorMsg: '',
      successMsg: '',
    }
  },
  computed: {
    validEmail () {
      return this.email.includes('@')
    },
    passwordMinLength () {
      return this.password.length >= 6
    },
    passwordsMatch () {
      return this.password === this.verifyPassword
    },
    validForm () {
      return this.validEmail && this.passwordMinLength && this.passwordsMatch && this.promoCode.trim().length > 0
    },
  },
  methods: {
    submit () {
      if (!this.validForm) {
        return
      }
      this.errorMsg = ''
      this.successMsg = ''
      this.$store.commit('showLoading')
      this.$store.dispatch('adminCreateUserNoCard', {
        email: this.email.trim(),
        password: this.password,
        promoCode: this.promoCode.trim(),
      })
      .then((response) => {
        if (response.data.status === 'FAILURE') {
          this.errorMsg = response.data.errMsg || 'Failed to create user.'
        } else {
          this.successMsg = `User ${response.data.account.email} created and validated.`
          this.email = ''
          this.password = ''
          this.verifyPassword = ''
          this.promoCode = ''
        }
      })
      .catch(() => {
        this.errorMsg = 'Failed to create user.'
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
  },
}
</script>

<style lang="scss">

</style>
